module.exports = __webpack_public_path__ + "static/media/desert6.023fc790.png";